import React, { useState, useEffect } from 'react';
import {
  Modal,
  Select,
  DatePicker,
  Button,
  Tabs,
  Spin,
  Input,
  Alert,
  message,
} from 'antd';
import TabContent from '../components/tabContent';
import {
  LoadingOutlined,
  FileOutlined,
  ExclamationCircleOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilter,
  getPuestos,
  getMarcas,
  getColumnas,
  getData,
  saveEvaluacion,
} from '../actions/evaluacionOptima';
import { StickyContainer, Sticky } from 'react-sticky';
import moment from 'moment';
import ReactExport from 'react-data-export';
import Workbook from 'react-xlsx-workbook-dynamic-column-width';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//const Excel = require('exceljs');

const { Option } = Select;

const { TabPane } = Tabs;

const { confirm, error, info } = Modal;

function EvaluacionOptima(props) {
  const dispatch = useDispatch();
  const puesto = useSelector((state) => state.evaluacionOptima.puesto);
  const loading = useSelector((state) => state.evaluacionOptima.loading);
  const puestos = useSelector((state) => state.evaluacionOptima.puestos);
  const indicadores = useSelector(
    (state) => state.evaluacionOptima.indicadores
  );
  const columnas = useSelector((state) => state.evaluacionOptima.columnas);

  const marca = useSelector((state) => state.evaluacionOptima.marca);
  const marcas = useSelector((state) => state.evaluacionOptima.marcas);
  const unidadNegocio = useSelector(
    (state) => state.evaluacionOptima.unidadNegocio
  );
  const fecha = useSelector((state) => state.evaluacionOptima.fecha);
  const mensaje = useSelector((state) => state.evaluacionOptima.message);
  const codigo = useSelector((state) => state.evaluacionOptima.code);
  const [unidades, setUnidades] = useState([]);
  const calificaciones = useSelector(
    (state) => state.evaluacionOptima.calificaciones
  );
  const fechaCierre = useSelector(
    (state) => state.evaluacionOptima.fechaCierre
  );
  const fechaValida = useSelector(
    (state) => state.evaluacionOptima.fechaValida
  );
  const ventasAPV = useSelector((state) => state.evaluacionOptima.ventasAPV);

  const CambiosGuardados = useSelector(
    (state) => state.evaluacionOptima.CambiosGuardados
  );

  /**constantes para mensaje de fecha */
  const fechaFormato = moment(fechaCierre).format('D/MMMM/YYYY');

  const mensajeFecha = fechaValida
    ? 'La fecha límite para captura es: ' + fechaFormato
    : 'La captura de información cerró el ' + fechaFormato;

  useEffect(() => {
    dispatch({ type: 'RESET_DATA_EO' });
    dispatch(getPuestos());
    dispatch(getMarcas());
    dispatch(getColumnas());
    //dispatch(getData())
  }, []);

  const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
      {({ style }) => (
        <DefaultTabBar
          {...props}
          className="site-custom-tab-bar"
          style={{ ...style }}
        />
      )}
    </Sticky>
  );

  function loadEvaluacion() {
    if (unidadNegocio == null || fecha == null || marca == null) {
      message.warning('Selecciona todos los filtros');
    } else {
      showConfirmSearch();
    }
  }

  function onSaveEvaluacion() {
    dispatch(saveEvaluacion());
  }

  function showConfirm() {
    const mod = indicadores.filter((o) => o.Modificado);

    if (mod.length > 0) {
      confirm({
        title: 'Resumen evaluación',
        icon: <ExclamationCircleOutlined />,
        content: getResumen(),
        onOk() {
          onSaveEvaluacion();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      error({
        title: 'No hay cambios para guardar',
        content: 'No se han realizado cambios en la evaluación ',
      });
    }
  }

  function showConfirmSearch() {
    const mod = indicadores.filter((o) => o.Modificado);
    if (mod.length > 0 && !CambiosGuardados) {
      info({
        title: 'Cambios sin guardar',
        icon: <ExclamationCircleOutlined />,
        content: 'Se perderá la información capturada. ¿Deseas continuar?',
        onOk() {
          dispatch(getData());
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      dispatch(getData());
    }
  }

  const getResumen = () => {
    return (
      <div>
        {puestos.map((p) => {
          return (
            <span key={p.Tipo}>
              {p.Tipo} : <b>{calificaciones[p.IdTipo]}</b> <br></br>
            </span>
          );
        })}
      </div>
    );
  };

  function onChangeValue(key, value, option) {
    if (key == 'marca') {
      dispatch(changeFilter('unidadNegocio', null));
      setUnidades(marcas[option.key].unidades);
    }

    if (key == 'mensaje') {
      dispatch(changeFilter('code', null));
      dispatch(changeFilter('message', ''));
    }
    dispatch(changeFilter(key, value));

    console.log(ventasAPV);
  }

  function onChangeDate(date, dateString) {
    dispatch(changeFilter('fecha', date));
  }

  function getIndicadoresExcel(idTipo) {
    let filtro = indicadores.filter((o) => o.puesto == idTipo);
    let obUnidad = unidades.filter((o) => o.id == unidadNegocio);
    let nombreAgencia = obUnidad.length == 0 ? '' : obUnidad[0].nombre;
    let obMarca = marcas.filter((o) => o.id == marca);
    let nombreMarca = obMarca.length == 0 ? '' : obMarca[0].nombre;

    let borde = {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    };
    let styleColumna = {
      fill: { fgColor: { rgb: 'D9D9D9' }, patternType: 'solid' },
      alignment: { horizontal: 'center' },
      border: borde,
    };
    let datos = [];

    /**Datos encabezado */
    let renglonMarca = [];
    renglonMarca.push({
      value: 'Marca: ',
      style: { font: { sz: '18' }, border: borde },
    });
    renglonMarca.push({
      value: nombreMarca,
      style: {
        font: { bold: true },
        border: borde,
        alignment: { horizontal: 'center' },
      },
    });
    datos.push(renglonMarca);

    let renglonUnidad = [];
    renglonUnidad.push({
      value: 'Unidad: ',
      style: { font: { sz: '18' }, border: borde },
    });
    renglonUnidad.push({
      value: nombreAgencia,
      style: {
        font: { bold: true },
        border: borde,
        alignment: { horizontal: 'center' },
      },
    });
    datos.push(renglonUnidad);

    let renglonFecha = [];
    let fechaExcel =
      fecha == null ? moment().format('MMM YY') : fecha.format('MMM YYYY');
    renglonFecha.push({
      value: 'Periodo: ',
      style: { font: { sz: '18' }, border: borde },
    });
    renglonFecha.push({
      value: fechaExcel,
      style: {
        font: { bold: true },
        border: borde,
        alignment: { horizontal: 'center' },
      },
    });
    datos.push(renglonFecha);

    let renglonCalificacion = [];
    renglonCalificacion.push({
      value: 'Calificacion: ',
      style: { font: { sz: '18' }, border: borde },
    });
    renglonCalificacion.push({
      value: Math.round(calificaciones[idTipo]) / 100,
      style: {
        font: { bold: true },
        border: borde,
        numFmt: '0.00%',
        alignment: { horizontal: 'center' },
      },
    });
    datos.push(renglonCalificacion);

    let col = [];
    let renglonEncabezado = [];
    renglonEncabezado.push({ value: 'Indicador', style: styleColumna });
    col.push({ title: '', width: { wpx: 650 } });
    columnas.map((c) => {
      col.push({ title: '', width: { wpx: c.Longitud } });
      renglonEncabezado.push({ value: c.Columna, style: styleColumna });
    });
    datos.push(renglonEncabezado);

    filtro.map((f) => {
      let renglon = [];

      let color = f.TipoIndicador == 'Titulo' ? '2F75B5' : 'FFFFFF';
      let colorFuente = f.TipoIndicador == 'Titulo' ? 'FFFFFF' : '000000';
      let alineacion = f.TipoIndicador == 'Indicador' ? 'left' : 'center';

      let styleIndicador = {
        font: {
          sz: '12',
          bold: f.CapturaCalificacion,
          color: {
            rgb: colorFuente,
          },
        },
        fill: {
          patternType: 'solid',
          fgColor: {
            rgb: color,
          },
        },
        alignment: {
          horizontal: alineacion,
          vertical: 'center',
          wrapText: true,
        },
        border: borde,
      };

      let cont = 0;
      let cadena = '';
      while (cont != f.Nivel) {
        if (f.TipoIndicador == 'Indicador') {
          cadena += '    ';
        }
        cont++;
      }
      renglon.push({ value: cadena + f.Indicador, style: styleIndicador });

      columnas.map((c) => {
        let valor = 0;
        let formato = '';
        if (f.Respuestas[c.IdColumna].TipoValor == '%') {
          valor = f.Respuestas[c.IdColumna].Valor / 100;
          formato = '0.00%';
        } else if (f.Respuestas[c.IdColumna].TipoValor == '$') {
          valor = Math.round(f.Respuestas[c.IdColumna].Valor * 100) / 100;
          formato = '$#,##0.00';
        } else {
          valor = f.Respuestas[c.IdColumna].Valor;
        }

        let styleCeldaDato = {
          font: {
            sz: '12',
            bold: f.CapturaCalificacion,
            color: {
              rgb: colorFuente,
            },
          },
          fill: {
            patternType: 'solid',
            fgColor: {
              rgb: color,
            },
          },
          alignment: {
            horizontal: c.IdColumna == 6 ? 'left' : 'center',
            vertical: 'center',
            wrapText: true,
          },
          border: borde,
          numFmt: formato,
        };

        if (!f.CapturaCalificacion && c.IdColumna == 5) {
          renglon.push({ value: '', style: styleCeldaDato });
        } else {
          renglon.push({ value: valor, style: styleCeldaDato });
        }
      });

      datos.push(renglon);
    });

    let datosExcel = [];
    datosExcel.push({ columns: col, data: datos });
    return datosExcel;
  }

  function nombreArchivo() {
    let obUnidad = unidades.filter((o) => o.id == unidadNegocio);
    let obMarca = marcas.filter((o) => o.id == marca);

    let nombreMarca = obMarca.length == 0 ? '' : obMarca[0].nombre;
    let nombreAgencia = obUnidad.length == 0 ? '' : obUnidad[0].nombre;
    let anio = fecha == null ? moment().format('YYYY') : fecha.format('YYYY');
    let mes = fecha == null ? moment().format('MM') : fecha.format('MM');
    //let nombreMarca = marcas.filter(o => o.id == marca).nombre;

    return (
      'EVAL - ' +
      nombreMarca +
      ' - ' +
      nombreAgencia +
      ' ' +
      mes +
      '/' +
      anio +
      '.xlsx'
    );
  }

  return (
    <div style={{ height: '90vh' }}>
      <Spin
        size="large"
        spinning={loading}
        tip="Cargando..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <div className={'m-eval-tituloEvaluacion'}>
          <div style={{ width: '15%', float: 'left' }}>Evaluación Optima</div>
          <div style={{ width: '75%', float: 'left' }}>
            <Alert
              style={{ width: '50%', marginLeft: '1%', marginBottom: '1%' }}
              showIcon={fechaCierre != null ? true : false}
              message={fechaCierre != null ? mensajeFecha : ''}
              type={
                fechaCierre != null ? (fechaValida ? 'info' : 'warning') : null
              }
            />
          </div>
        </div>

        <div className={'m-eval-header'}>
          <div className={'m-eval-inputDiv'}>
            <Select
              style={{ width: 200 }}
              placeholder="Marca"
              size={'small'}
              value={marca}
              disabled={puesto == 1 ? false : true}
              onChange={(value, option) =>
                onChangeValue('marca', value, option)
              }
            >
              {marcas.map((m, index) => {
                return (
                  <Option value={m.id} key={index}>
                    {m.nombre}
                  </Option>
                );
              })}
            </Select>
          </div>
          <div className={'m-eval-inputDiv'}>
            <Select
              style={{ width: 200 }}
              placeholder="Unidad de negocio"
              size={'small'}
              value={unidadNegocio}
              disabled={puesto == 1 ? false : true}
              onChange={(value, option) =>
                onChangeValue('unidadNegocio', value, option)
              }
            >
              {unidades.map((item, index) => (
                <Option key={index} value={item.id}>
                  {item.nombre}
                </Option>
              ))}
            </Select>
          </div>
          <div className={'m-eval-inputDiv'}>
            <DatePicker
              value={fecha}
              onChange={onChangeDate}
              placeholder="Periodo"
              style={{ width: 120 }}
              picker="month"
              size={'small'}
              disabled={puesto == 1 ? false : true}
            />
          </div>

          <div className={'m-eval-inputDiv'}>
            <Input
              style={{ width: 150 }}
              suffix={<FileOutlined />}
              readOnly
              placeholder={'Calificacion'}
              size={'small'}
              defaultValue={calificaciones[puesto]}
              key={`${Math.floor(Math.random() * 1000)}-min`}
            ></Input>
          </div>

          <div className={'m-eval-inputDiv'}>
            <Button
              type="primary"
              size={'small'}
              onClick={loadEvaluacion}
              style={{ visibility: puesto == 1 ? 'visible' : 'hidden' }}
            >
              Buscar{' '}
            </Button>
          </div>
          <div className={'m-eval-inputDiv'}>
            <Button
              type="primary"
              style={{ background: 'green', borderColor: 'green' }}
              size={'small'}
              disabled={!fechaValida}
              onClick={showConfirm}
            >
              Guardar
            </Button>
          </div>

          <div className={'m-eval-inputDiv'}>
            <ExcelFile
              filename={nombreArchivo()}
              element={
                <Button size={'small'}>
                  {' '}
                  <ArrowDownOutlined /> Descargar
                </Button>
              }
            >
              {puestos.map((p) => {
                return (
                  <ExcelSheet
                    key={p.IdTipo}
                    dataSet={getIndicadoresExcel(p.IdTipo)}
                    name={p.Tipo}
                  />
                );
              })}
            </ExcelFile>
          </div>

          <div className={'m-eval-inputDiv'}>
            <Alert
              showIcon={codigo != null ? true : false}
              message={mensaje}
              type={codigo == 0 ? 'success' : codigo == -1 ? 'error' : null}
              onClick={() => onChangeValue('mensaje', null)}
            />
          </div>
        </div>

        <StickyContainer
          style={{
            marginLeft: '2%',
            float: 'left',
            maxWidth: '95%',
            width: '95%',
          }}
        >
          <Tabs
            size={'small'}
            type={'card'}
            onChange={(key, value) => onChangeValue('puesto', key)}
            activeKey={puesto}
            renderTabBar={renderTabBar}
          >
            {puestos.map((p) => {
              return (
                <TabPane tab={p.Tipo} key={p.IdTipo}>
                  <TabContent />
                </TabPane>
              );
            })}
          </Tabs>
        </StickyContainer>
      </Spin>
    </div>
  );
}

export default EvaluacionOptima;
